// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2FKmJ","title":"ClientCherryInfo_title__1VaQF","itemText":"ClientCherryInfo_itemText__3F0Oq"};